module.exports = __webpack_public_path__ + "static/media/discovery-logo.3ba23252.jpg";